import axios from 'axios'
// import Dygraph from '@/components/Dygraphs/Dygraph.vue'

/**
 * Auto Encoder Analysis
 */

export default {
  computed: {

  }, // end - computed
  methods: {
    /**
     * Clear 버튼 클릭
     */
    async onClickClear () {
      this.resultText = ''
    }, // end - onClickClear

    /** Run 버튼 클릭 */
    async onClickRun () {
      if (!this.params.trainData) {
        alert('Training Dataset 파일을 선택하세요.')
        return
      }

      if (!this.params.analyzeData) {
        alert('Analysis Dataset 파일을 선택하세요.')
        return
      }

      if (!this.params.isUseDefault && !this.params.algorithmSrc) {
        alert('Python User Script 파일을 선택하세요.')
        return
      }

      await this.executeAlgorithm()
    }, // end - onClickRun

    /**
     * Training dataset 파일 선택시 파일 내용 읽기
     * @param {*} file
     */
    onChangeTrainFile (file) {
      this.loadFileData(file, 'train')
    }, // end - onChangeTrainFile

    /**
     * Analysis dataset 파일 선택시 파일 내용 읽기
     * @param {} file
     */
    onChangeAnalyzeFile (file) {
      this.loadFileData(file, 'analyze')
    }, // end - onChangeAnalyzeFile

    /**
     * Phthon User Script 파일 선택시 파일 내용 읽기
     * @param {*} file
     */
    onChangeSrcFile (file) {
      this.loadFileData(file, 'src')
    }, // end - onChangeSrcFile

    /**
     * Result Text에 내용 추가
     * @param {*} msg
     */
    appendResultText (msg) {
      this.resultText += `${msg}\n`
    }, // end - appendResultText

    /**
     * 파일 내용 읽기
     * @param {*} file
     * @param {*} reqType
     */
    loadFileData (file, reqType) {
      if (file) {
        let reader = new FileReader()
        this.appendResultText(`파일을 읽고 있습니다. ${file.name}`)
        reader.readAsText(file, 'UTF-8')
        reader.onload = (evt) => {
          this.appendResultText('파일 읽기 완료.')
          if (reqType === 'src') {
            this.params.algorithmSrcName = file.name
            this.params.algorithmSrc = evt.target.result
          } else if (reqType === 'analyze') {
            this.params.analyzeFileName = file.name
            this.params.analyzeData = evt.target.result
          } else if (reqType === 'train') {
            this.params.trainFileName = file.name
            this.params.trainData = evt.target.result
          }
        }
        reader.onerror = (evt) => {
          this.appendResultText(`파일 읽기 에러 : ${evt}`)
        }
      }
    }, // end - loadFileData()

    /**
     * 알고리즘 수행 요청
     */
    async executeAlgorithm () {
      // let reqMap = {}
      this.appendResultText('알고리즘 수행 요청')
      // let isUseDefault = this.isUseDefaultAlgorithm
      // let algorithmName = $('#mainBody').context.getElementById('algorithmName').value
      // reqMap['isUseDefault'] = isUseDefault
      // if (!isUseDefault) {
      //   reqMap['algorithmSrc'] = this.params.algorithmSrc
      //   reqMap['algorithmSrcName'] = this.params.algorithmSrcName
      // }
      // reqMap['trainFileName'] = this.params.trainFileName
      // reqMap['trainData'] = this.params.trainData
      // reqMap['analyzeFileName'] = this.params.analyzeFileName
      // reqMap['analyzeData'] = this.params.analyzeData

      try {
        let response = await axios.post('http://192.168.0.13:8080/executeAlgorithm', this.params)
        let resultSet = this.parseResultSet(response.data)
        let result = JSON.parse(resultSet.RESULT)

        this.convertDyGraphData(result[0].data) // DyGraph에 맞게 Data 변환
      } catch (error) {
        console.log(error)
        this.appendResultText('서버 에러 응답 : ' + error)
      }
    }, // end - onExecuteAlgorithm()

    /**
     * DyGraph에 맞게 Data 변환
     * 변환된 데이터 : [[1, 10], [2, 20], [3, 30]]
     * @param {*} data {0: 10, 1: 20, 2: 30}
     */
    convertDyGraphData (data) {
      let graphData = []
      for (let index in data) {
        let value = data[index]
        graphData.push([Number(index) + 1, value])
      }

      this.graphData = graphData
    }, // end - convertDyGraphData

    /**
     * 서버에서 받은 데이터 파싱
     * @param {*} message
     * @returns
     */
    parseResultSet (message) {
      let resultMap = {}
      try {
        if (message.success) {
          resultMap['SUCCESS'] = message.success
          resultMap['PROCESS_TIME'] = message.resultMap.PROCESS_TIME
          resultMap['RESULT'] = message.resultMap.RESULT_DATA_KEY
          this.appendResultText('수행 경과 시간 : ' + resultMap['PROCESS_TIME'] + ' [ms]')

          // this.appendResultText(resultMap['RESULT'])
          this.appendResultText(message.resultMap.RESULT_DATA_KEY)
        } else {
          resultMap['ERROR'] = message.errorMessage
          resultMap['PROCESS_TIME'] = 'NONE'
          resultMap['RESULT'] = 'NONE'
          this.appendResultText('에러: \n' + resultMap['ERROR'])
        }
      } catch (error) {
        this.appendResultText('Exception: \n' + error)
      }
      return resultMap
    } // end - parseResultSet
  }, // end - methods
  data () {
    return {
      params: { // 서버에 데이터 요청하기 위한 파라미터
        trainFileName: null, // 선택된 Training Dataset 파일명
        trainData: null, // 선택된 Training Dataset 파일내용
        analyzeFileName: null, // 선택된 Analysis Dataset 파일명
        analyzeData: null, // 선택된 Analysis Dataset 파일내용
        isUseDefault: true, // Default Script 또는 User Script 여부(true : Default Script)
        algorithmSrcName: null, // 선택된 Python User Script 파일명
        algorithmSrc: null // 선택된 Python User Script 파일 내용
      },
      trainFile: null, // Training Dataset 파일
      analyzeFile: null, // Analysis Dataset 파일

      pythonUserScriptFile: null, // Python User Script 파일
      resultText: '', // Result Text

      labels: ['x', 'Anomaly_Score'], // Chart series 목록
      graphData: []// Chart Data, 형식 : [[1, 10], [2, 20], [3, 30]]
    } // end - data - return
  } // end - data
}
